module.exports = __webpack_public_path__ + "img/Ulta_case_study_21.ee47c018.jpg";